import React, { useEffect } from "react";
import {
  BannerBgImage,
  arrowImage,
  MonitorIcon,
  MentorshipIcon,
  AiIntegrationIcon,
  FeatureIconContainer,
  ChatBotImage,
  DataAutomation,
  StarIcon,
  FooterLogo,
  MailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  InstagramIcon,
} from "../../assets";
import Navbar from "../../component/Navbar";
import VideoSlider from "../../component/Carousel";
import { Paths } from "../../routes";
import { useNavigate, useParams } from "react-router-dom";
import { navItem } from "../../helpers/common";

const Index = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const categories = [
    {
      id: 1,
      categoryName: "mobile app",
    },
    {
      id: 2,
      categoryName: "full stack development",
    },
    {
      id: 3,
      categoryName: "medical software",
    },
    {
      id: 4,
      categoryName: "web design",
    },
    {
      id: 5,
      categoryName: "e-commerce",
    },
    {
      id: 6,
      categoryName: "blockchain",
    },
    {
      id: 7,
      categoryName: "artifical intelligence",
    },
    {
      id: 8,
      categoryName: "b2B",
    },
    {
      id: 9,
      categoryName: "data analysis",
    },
    {
      id: 10,
      categoryName: "b2C",
    },
  ];

  useEffect(() => {
    if (navItem?.find((item) => item.id === section)) {
      setTimeout(() => {
        document
          .getElementById(`${section}-section`)
          .scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      setTimeout(() => {
        document
          .getElementById("landing-page-main")
          .scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }, [section]);

  const specialties = [
    {
      id: 1,
      specialtiesName: "Saas Development",
      specialtiesIcon: MonitorIcon,
      specialtiesPara:
        "We will help you build any web, or mobile, application and integrate the necessary components to ensure you maximize your earning potential.",
    },
    {
      id: 2,
      specialtiesName: "Mentorship",
      specialtiesIcon: MentorshipIcon,
      specialtiesPara:
        "A 1 to 1 Mentorship scheme with Yahya MQA, a tech entrepeneur with vast experience in SaaS and monetizing in all different industries. Limited Spaces Available.",
    },
    {
      id: 3,
      specialtiesName: "AI integration",
      specialtiesIcon: AiIntegrationIcon,
      specialtiesPara:
        "AI has very rapidly become the forefront of thriving businesses with a race to ensure companies are not left behind by not implementing it into their organisations. ",
    },
  ];
  const stages = [
    {
      id: 1,
      stageName: "Research & Strategy",
      stageDetail:
        "Before starting your SaaS, do you know exactly where you will find the ideal users who are willing to pay for your service?",
    },
    {
      id: 2,
      stageName: "Development",
      stageDetail:
        "Is it worth pursuing your idea? You will need to determine whether the cost and time is worth it. A simple MVP to prove its possible is the first step!",
    },
    {
      id: 3,
      stageName: "Design",
      stageDetail:
        "Over 90% of users will exit your app and never use it again after the first time. Which is why it is pivotal to ensure an excellent experience for your users.",
    },
    {
      id: 4,
      stageName: "Earning",
      stageDetail:
        "Having a great app means nothing if you do not know how to earn from it. How do you put this in front of your ideal customers? Get in touch!",
    },
  ];
  return (
    <div className="h-full" id="landing-page-main">
      {/* Banner Section start */}
      <section
        className="pt-[37px] h-[686px] flex flex-col bg-[#141414] bg-auto bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${BannerBgImage})` }}
      >
        <Navbar />
        <div className="pt-[73px] h-full flex flex-col md:justify-end justify-start items-center md:gap-[60px] gap-10">
          <div className="w-full md:max-w-[505px] max-w-full md:px-0 px-4 flex flex-col justify-center items-center gap-6">
            <h1 className="m-0 md:text-[56px] text-[32px] font-bold md:leading-[68px] leading-[48px] -tracking-[0.02em] text-white text-center">
              Unleash your digital innovation with AI.
            </h1>
            <p className="m-0 w-full md:max-w-[505px] max-w-full md:px-0 px-4 text-base font-medium leading-6 text-[#FFFFFFCC] text-center">
              We believe in the power of collaboration and innovation. Let us
              help you bring your digital ideas to life and get you earning from
              today.
            </p>
            <button
              type="button"
              className="mt-[5px] px-5 w-full max-w-[209px] h-[56px] flex items-center gap-[10px] text-base font-bold text-white leading-6 bg-[#B30707] border border-[#F81515] rounded-full whitespace-nowrap"
              onClick={() => navigate(Paths.Contact)}
            >
              Get a Free Quote
              <img src={arrowImage} alt="arrowImage" width={39} height={39} />
            </button>
          </div>
          <div className="w-full 2xl:max-w-[924px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 mx-auto flex flex-wrap justify-center items-center gap-x-4 lg:gap-y-[27px] gap-5">
            {categories.map((item) => {
              return (
                <div
                  key={item.id}
                  className="2xl:text-xl lg:text-lg text-base font-medium 2xl:leading-[30px] lg:leading-6 leading-5 text-white capitalize py-2 px-4 rounded-full bg-[#FFFFFF0A] border border-[#FFFFFF14] whitespace-nowrap"
                >
                  {item.categoryName}
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* Banner Section end */}

      {/* Specialties section start */}
      <section className="pt-[89px] bg-[#141414]">
        <div className="w-full md:max-w-[528px] max-w-full md:px-0 px-4 mx-auto pb-16 flex flex-col justify-center items-center gap-4">
          <h3 className="m-0 lg:text-[40px] text-[32px] font-bold lg:leading-[48px] leading-9 text-white capitalize">
            our specialties
          </h3>
          <p className="text-base leading-6 font-normal text-center text-[#FFFFFFE0]">
            Whether you’re an individual or a well established business, you
            will benefit from at least one of the three offerings.
          </p>
        </div>
        <div className="lg:pb-[72px] pb-[42px] w-full 2xl:max-w-[1240px] xl:max-w-[991px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 mx-auto grid 2xl:grid-cols-[360px_360px_360px] xl:grid-cols-[300px_300px_300px] lg:grid-cols-[240px_240px_240px] md:grid-cols-3 grid-cols-1 lg:gap-0 gap-4 justify-between">
          {specialties.map((specialtiesItem) => {
            return (
              <div
                key={specialtiesItem.id}
                className="flex flex-col justify-center items-center gap-6"
              >
                <div className="w-20 h-20 rounded-full flex justify-center items-center border border-[#FFFFFF1F] bg-[#FFFFFF14]">
                  <img
                    src={specialtiesItem.specialtiesIcon}
                    alt="specialtiesImage"
                  />
                </div>
                <div className="flex flex-col justify-center items-center gap-3">
                  <h4 className="m-0 text-white 2xl:text-2xl text-xl font-bold 2xl:leading-8 leading-6">
                    {specialtiesItem.specialtiesName}
                  </h4>
                  <p className="m-0 2xl:text-base text-sm text-[#FFFFFFE0] text-center font-normal leading-6">
                    {specialtiesItem.specialtiesPara}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      {/* Specialties section end */}

      {/* Key stages of SaaS Development section start */}
      <section
        className="lg:pt-[72px] pt-[42px] bg-[#141414]"
        id="saas-section"
      >
        <div className="mb-16 w-full max-w-[627px] mx-auto flex flex-col justify-center items-center gap-4">
          <h3 className="w-full max-w-[370px] m-0  md:text-[40px] text-[32px] font-bold md:leading-[48px] leading-9-tracking-[0.02em] text-white text-center">
            4 Key Stages of{" "}
            <span className="bg-gradient-to-r from-[#F81515] from-[-16.58%] to-[#FD9999] to-[54.82%] bg-clip-text text-transparent">
              SaaS Development
            </span>
          </h3>
          <p className="m-0 text-base font-normal leading-6 text-center text-[#FFFFFFCC]">
            Our team of skilled developers specializes in creating robust and
            scalable SaaS products. From ideation to deployment, we guide you
            through the entire development process.{" "}
          </p>
        </div>
        <div className="w-full 2xl:max-w-[1240px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 mx-auto grid md:grid-cols-2 grid-cols-1 2xl:grid-rows-[320px_320px] xl:grid-rows-[250px_250px] grid-rows-auto lg:gap-10 gap-5">
          {stages.map((stageItem) => {
            return (
              <div className="w-full flex justify-start items-center border border-[#FFFFFF29] bg-[#FFFFFF14] backdrop-blur-[80px] rounded-3xl">
                <div className="w-full h-auto 2xl:max-w-[456px] xl:max-w-[340px] max-w-full xl:p-0 p-6 mx-auto flex justify-start items-start xl:gap-6 gap-4">
                  <div className="2xl:min-w-[72px] xl:min-w-[62px] min-w-[52px] 2xl:h-[72px] xl:h-[62px] h-[52px] flex justify-center items-center rounded-full border border-[#FFFFFF1F] bg-[#FFFFFF14] backdrop-blur-[60px]">
                    <h5 className="m-0 2xl:text-[40px] xl:text-3xl text-2xl font-medium -tracking-[0.02em] text-white leading-[48px]">
                      {stageItem.id}
                    </h5>
                  </div>
                  <div className="flex flex-col xl:gap-6 gap-4">
                    <h3 className="m-0 2xl:text-[32px] xl:text-[26px] text-xl font-bold 2xl:leading-10 xl:leading-9 leading-6 text-white">
                      {stageItem.stageName}
                    </h3>
                    <p className="m-0 2xl:text-lg xl:text-base text-sm font-medium leading-7 text-[#FFFFFFCC]">
                      {stageItem.stageDetail}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="pt-[80px] pb-[52px] w-full flex justify-center items-center">
          <button
            type="button"
            className="mt-[5px] px-5 w-full max-w-[165px] h-[56px] flex items-center gap-[10px] text-base font-bold text-white leading-6 bg-[#B30707] border border-[#F81515] rounded-full whitespace-nowrap"
            onClick={() => navigate(Paths.Contact)}
          >
            Book a Call
            <img src={arrowImage} alt="arrowImage" width={39} height={39} />
          </button>
        </div>
      </section>
      {/* Key stages of SaaS Development section end */}

      {/* Video start */}
      <section
        className="lg:pt-[89px] pt-[42px] bg-[#FFFFFF14]"
        id="mentorship-section"
      >
        <div className="w-full md:max-w-[766px] max-w-full md:px-0 px-4 mx-auto pb-12 flex flex-col justify-center items-center md:gap-[64px] gap-10">
          <h3 className="w-full md:max-w-[654px] m-0 md:text-[48px] text-[32px] font-bold md:leading-[58px] leading-9 -tracking-[0.02em] text-white text-center">
            <span className="bg-gradient-to-r from-[#F81515] from-[-16.58%] to-[#FD9999] to-[54.82%] bg-clip-text text-transparent">
              Mentorship:
            </span>{" "}
            Empower yourself with knowledge.
          </h3>
          <p className="m-0 text-base font-normal leading-6 text-center text-[#FFFFFFCC] max-w-[570px]">
            Our mentorship program is designed to businesses at all stages.
            Whether you are at the idea stage, or a fully functioning app -
            there is always merit in mentorship to scale further.
          </p>
        </div>

        <VideoSlider />

        <div className="w-full flex justify-center items-center pt-[54px] pb-[72px]">
          <button
            type="button"
            className="px-1 pr-[4.5px] pl-4 min-h-[56px] h-[56px] flex items-center gap-[10px] text-base font-bold text-white leading-6 bg-[#B30707] border border-[#F81515] rounded-full whitespace-nowrap"
            onClick={() => navigate(Paths.Contact)}
          >
            Get Mentorship
            <img alt="arrowImage" width="39" height="39" src={arrowImage} />
          </button>
        </div>
      </section>
      {/* Video end */}

      {/* AI Integration section start */}
      <section
        className="lg:pt-[72px] pt-[42px] bg-[#141414]"
        id="ai-integration-section"
      >
        <div className="pb-16 w-full md:max-w-[766px] max-w-full md:px-0 px-4 mx-auto flex flex-col justify-center items-center gap-4">
          <h3 className="w-full md:max-w-[654px] max-w-full md:px-0 px-4 m-0 md:text-[48px] sm:text-4xl text-[28px] font-bold md:leading-[58px] sm:leading-[48px] leading-8 -tracking-[0.02em] text-white text-center">
            <span className="bg-gradient-to-r from-[#F81515] from-[-16.58%] to-[#FD9999] to-[54.82%] bg-clip-text text-transparent">
              AI Integration:
            </span>{" "}
            Don’t fall behind your competitors.
          </h3>
          <p className="m-0 lg:text-base text-sm font-normal lg:leading-6 leading-5 text-center text-[#FFFFFFCC] max-w-[570px]">
            In a recent interview, Jeff Bezos said 95% of Amazon’s operations
            are focusing on AI. Without AI implemented in your business, it’s
            only a matter of time before you fall behind if you do not utilize
            this revolutionary technology in your business workflows.
          </p>
        </div>
        <div className="w-full 2xl:max-w-[1240px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 mx-auto grid 2xl:grid-cols-[791px_425px] xl:grid-cols-[640px_360px] lg:grid-cols-[440px_304px] md:grid-cols-[350px_264px] grid-cols-1 2xl:grid-rows-[452px] xl:grid-rows-[387px] grod-rows-auto gap-6">
          <div className="w-full flex justify-center items-center border border-[#FFFFFF29] bg-[#FFFFFF14] backdrop-blur-[80px] rounded-3xl xl:p-0 p-5">
            <div className="w-full 2xl:max-w-[695px] xl:max-w-[495px] md:max-w-[370px] max-w-full flex flex-col 2xl:gap-10 lg:gap-5 gap-4">
              <div className="w-full max-w-[513px] flex flex-col gap-3">
                <h3 className="m-0 2xl:text-2xl xl:text-xl text-lg font-bold 2xl:leading-8 leading-6 text-white">
                  AI voice agents for end-to-end optimization
                </h3>
                <p className="m-0 xl:text-lg lg:text-base text-sm font-medium xl:leading-7 lg:leading-6 leading-5 text-[#FFFFFFCC]">
                  Our Voice AI Agent, comes with a human-like voice that is
                  natural and relatable. Add a level of authenticity and
                  engagement.
                </p>
              </div>
              <img src={FeatureIconContainer} alt="FeatureIconContainer" />
            </div>
          </div>
          <div className="w-full flex justify-center items-center border border-[#FFFFFF29] bg-[#FFFFFF14] backdrop-blur-[80px] rounded-3xl">
            <div className="w-full flex flex-col xl:pt-[30px] pt-5 xl:pl-12 p-5">
              <div className="w-full md:max-w-[235px] max-w-full flex flex-col gap-3">
                <h3 className="m-0 2xl:text-2xl xl:text-xl text- font-bold 2xl:leading-8 leading-6 text-white">
                  Customer chatbots
                </h3>
                <p className="m-0 xl:text-lg text-base font-medium xl:leading-7 leading-5 text-[#FFFFFFCC]">
                  Revolutionize Customer Support with AI Chatbots
                </p>
              </div>
              <img src={ChatBotImage} alt="ChatBotImage" />
            </div>
          </div>
        </div>
        <div className="w-full 2xl:max-w-[1240px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 mt-6 mx-auto grid 2xl:grid-cols-[425px_791px] xl:grid-cols-[360px_640px] lg:grid-cols-[304px_440px] md:grid-cols-[264px_350px] grid-cols-1 2xl:grid-rows-[452px] xl:grid-rows-[387px] grod-rows-auto gap-6 overflow-hidden">
          <div className="w-full flex justify-center items-center border border-[#FFFFFF29] bg-[#FFFFFF14] backdrop-blur-[80px] rounded-3xl xl:p-0 p-5">
            <div className="w-full 2xl:max-w-[695px] xl:max-w-[495px] md:max-w-[250px] max-w-full flex flex-col items-center 2xl:gap-10 gap-5">
              <div className="w-full md:max-w-[331px] max-w-full flex flex-col gap-3">
                <h3 className="m-0 2xl:text-2xl xl:text-xl text-lg font-bold 2xl:leading-8 leading-6 text-white">
                  Streamline manual processes
                </h3>
                <p className="m-0 xl:text-lg text-base font-medium xl:leading-7 leading-5 text-[#FFFFFFCC]">
                  Our AI integration solutions can be tailored to your specific
                  needs.
                </p>
              </div>
              <div className="flex flex-col gap-[10px] w-full lg:max-w-fit md:max-w-[220px] max-w-full">
                <div className="w-full flex justify-center py-3 2xl:px-10 px-5 rounded-xl border border-[#FFFFFF1F] bg-[#FFFFFF14] md:max-w-fit m-auto max-w-full">
                  <span className="2xl:text-lg xl:text-base text-sm 2xl:leading-7 xl:leading-6 leading-5 whitespace-nowrap font-medium text-white">
                    Increase productivity
                  </span>
                </div>
                <div className="w-full flex justify-center py-3 2xl:px-10 px-5 rounded-xl border border-[#FFFFFF1F] bg-[#FFFFFF14] md:max-w-fit m-auto max-w-full">
                  <span className="2xl:text-lg xl:text-base text-sm 2xl:leading-7 xl:leading-6 leading-5 whitespace-nowrap font-medium text-white">
                    Reduce human error
                  </span>
                </div>
                <div className="w-full flex justify-center py-3 2xl:px-10 px-5 rounded-xl border border-[#FFFFFF1F] bg-[#FFFFFF14] md:max-w-fit m-auto max-w-full">
                  <span className="2xl:text-lg xl:text-base text-sm 2xl:leading-7 xl:leading-6 leading-5 whitespace-nowrap font-medium text-white">
                    Enhance customers experience
                  </span>
                </div>
                <div className="w-full flex justify-center py-3 2xl:px-10 px-5 rounded-xl border border-[#FFFFFF1F] bg-[#FFFFFF14] md:max-w-fit m-auto max-w-full">
                  <span className="2xl:text-lg xl:text-base text-sm 2xl:leading-7 xl:leading-6 leading-5 whitespace-nowrap font-medium text-white">
                    Improve design thinking
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center xl:items-center items-start border border-[#FFFFFF29] bg-[#FFFFFF14] backdrop-blur-[80px] rounded-3xl">
            <div className="w-full flex flex-col xl:h-auto h-full xl:justify-center justify-between">
              <div className="w-full flex flex-col gap-3 xl:pt-8 pt-5 xl:pl-12 pl-5">
                <h3 className="m-0 2xl:text-2xl xl:text-xl text-lg font-bold 2xl:leading-8 leading-6 text-white">
                  Data automation
                </h3>
                <p className="m-0 xl:text-lg text-base font-medium xl:leading-7 leading-5 text-[#FFFFFFCC]">
                  Our AI-powered data automation solutions are designed to
                  streamline your operations, reduce manual effort, and improve
                  accuracy. By automating repetitive tasks,.
                </p>
              </div>
              <img src={DataAutomation} alt="dataAutomation" />
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center items-center pt-[49px] pb-[52px]">
          <button
            type="button"
            className="mt-[5px] px-5 w-full max-w-[209px] h-[56px] flex items-center gap-[10px] text-base font-bold text-white leading-6 bg-[#B30707] border border-[#F81515] rounded-full whitespace-nowrap"
            onClick={() => navigate(Paths.Contact)}
          >
            Get a Free Quote
            <img alt="arrowImage" width="39" height="39" src={arrowImage} />
          </button>
        </div>
      </section>
      {/* AI Integration section end */}

      {/* our cilent say section start */}
      <section className="lg:pt-[72px] pt-[42px]  bg-[#FFFFFF14] relative">
        <div className="w-full max-w-[1240px] mx-auto flex flex-col">
          <div className="w-full lg:pb-[205px] md:pb-[150px] pb-[40px] text-center">
            <h3 className="lg:text-5xl md:text-[40px] sm:text-3xl text-[28px] font-bold lg:leading-[58px] md:leading-[48px] sm:leading-8 leading-[30px] -tracking-[0.02em] text-white">
              What our cilents say
            </h3>
          </div>
        </div>
        <div className="lg:pb-[74px] md:pb-[64px] pb-[34px] md:pt-0 pt-[34px] relative w-full h-full md:min-h-[330px] min-h-full bg-[#FFFFFF0A] backdrop-blur-[60px]">
          <div className="w-full 2xl:max-w-[1139px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 md:absolute static -top-[30%] md:-translate-x-1/2 translate-x-0 left-1/2 mx-auto grid 2xl:grid-cols-[353px_353px_353px] xl:grid-cols-[314px_314px_314px] lg:grid-cols-[230px_230px_230px] md:grid-cols-3 grid-cols-1 2xl:gap-10 xl:gap-8 gap-6">
            <div className="lg:p-8 p-6 rounded-xl border border-[#FFFFFF1F] bg-[#FFFFFF0A]">
              <div className="flex items-center gap-1">
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
              </div>
              <p className=" pt-4 pb-10 m-0 xl:text-base text-sm xl:leading-6 leading-4 -tracking-[0.09px] font-normal text-white">
                "This agency is amazing. Before this, our biggest problem was
                working with teams who weren’t responsive. But you guys are
                great!"
              </p>
              <span className="text-sm leading-6 -tracking-[0.01em] font-normal text-white">
                Recruitment Client
              </span>
            </div>
            <div className="lg:p-8 p-6 rounded-xl border border-[#FFFFFF1F] bg-[#FFFFFF0A]">
              <div className="flex items-center gap-1">
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
              </div>
              <p className=" pt-4 pb-10 m-0 xl:text-base text-sm xl:leading-6 leading-4 -tracking-[0.09px] font-normal text-white">
                "Yahya helped me build my first ever app. I had no knowledge and
                am now making $2k every month in recurring income."
              </p>
              <span className="text-sm leading-6 -tracking-[0.01em] font-normal text-white">
                Mentorship
              </span>
            </div>
            <div className="lg:p-8 p-6 rounded-xl border border-[#FFFFFF1F] bg-[#FFFFFF0A]">
              <div className="flex items-center gap-1">
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
                <img src={StarIcon} alt="StarIcon" />
              </div>
              <p className=" pt-4 pb-10 m-0 xl:text-base text-sm xl:leading-6 leading-4 -tracking-[0.09px] font-normal text-white">
                "We implemented AI into our workflow and observed our business
                saving hundreds of hours as a business every single week!
                Recommend!"
              </p>
              <span className="text-sm leading-6 -tracking-[0.01em] font-normal text-white">
                Data Client
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* our cilent say section end */}

      {/* Project in mind section start */}
      <section className="h-full md:max-h-[480px] max-h-fit z-10 relative md:pt-[120px] pt-[30px] md:pb-0 pb-[30px] bg-[#141414]">
        <div className="w-full 2xl:max-w-[1240px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-[calc(100%_-_32px)] mx-auto flex justify-center items-center bg-[#FFFFFF1F] rounded-[32px] py-[72px] border border-[#FFFFFF29] backdrop-blur-[120px]">
          <div className="w-full md:max-w-[876px] max-w-full md:px-0 px-5 flex flex-col justify-center items-center">
            <h3 className="m-0 pb-10 2xl:text-5xl xl:text-4xl md:text-3xl sm:text-2xl text-xl 2xl:leading-[58px] xl:leading-10 md:leading-8 leading-7 -tracking-[0.02em] font-bold text-white text-center">
              Have a project in mind? Let’s collabrate
            </h3>
            <div className="pb-[60px] flex items-center justify-center md:flex-nowrap flex-wrap gap-4">
              <div className="p-[1px] bg-gradient-to-r from-[#B30707A3] to-[#FD9999A3] rounded-full">
                <div className="bg-[#303030] rounded-full px-4 py-2">
                  <p className="md:text-lg sm:text-base text-sm font-medium md:leading-7 sm:leading-6 leading-5 text-white">
                    Saas Development
                  </p>
                </div>
              </div>
              <div className="p-[1px] bg-gradient-to-r from-[#B30707A3] to-[#FD9999A3] rounded-full">
                <div className="bg-[#303030] rounded-full px-4 py-2">
                  <p className="md:text-lg sm:text-base text-sm font-medium md:leading-7 sm:leading-6 leading-5 text-white">
                    Mentorship
                  </p>
                </div>
              </div>
              <div className="p-[1px] bg-gradient-to-r from-[#B30707A3] to-[#FD9999A3] rounded-full">
                <div className="bg-[#303030] rounded-full px-4 py-2">
                  <p className="md:text-lg sm:text-base text-sm font-medium md:leading-7 sm:leading-6 leading-5 text-white">
                    AI Integrations
                  </p>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="mt-[5px] px-5 w-full max-w-[209px] h-[56px] flex items-center gap-[10px] text-base font-bold text-white leading-6 bg-[#B30707] border border-[#F81515] rounded-full whitespace-nowrap"
              onClick={() => navigate(Paths.Contact)}
            >
              Get a Free Quote
              <img alt="arrowImage" width="39" height="39" src={arrowImage} />
            </button>
          </div>
        </div>
      </section>
      {/* Project in mind section end */}

      {/* Footer section start */}
      <section className="h-full md:max-h-[516px] max-h-fit bg-[#FFFFFF1F] backdrop-blur-[80px] md:pb-12 pb-7">
        <div className="w-full 2xl:max-w-[1240px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 mx-auto lg:pt-[160px] md:pt-[120px] pt-[40px]">
          <div className="w-full flex justify-between pb-10 border-b border-[#FFFFFF1F] lg:flex-nowrap flex-wrap md:gap-0 gap-3">
            <div className="flex flex-col gap-8">
              <img
                src={FooterLogo}
                alt="logo"
                className="w-auto max-h-[32px]"
              />
              {/* <div className="flex gap-4">
                <img
                  src={FacebookIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                />
                <img
                  src={LinkedinIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                />
                <img
                  src={TwitterIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                />
                <img
                  src={InstagramIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/incognetolabs?igsh=MXRsazF5bzZrcnB0bg==",
                      "_blank"
                    )
                  }
                />
              </div> */}
            </div>
            <div className="flex flex-col gap-5">
              <h5 className="m-0 text-lg leading-7 font-bold text-white">
                Company
              </h5>
              <ul className="list-none flex flex-col gap-4">
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() =>
                    document
                      .getElementById("landing-page-main")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Home
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() =>
                    document
                      .getElementById("saas-section")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Saas Developments
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() =>
                    document
                      .getElementById("mentorship-section")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Mentorship
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() =>
                    document
                      .getElementById("ai-integration-section")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                >
                  AI Integrations
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() => navigate(Paths.Contact)}
                >
                  Contact
                </li>
              </ul>
            </div>
            {/* <div className="flex flex-col gap-5">
              <h5 className="m-0 text-lg leading-7 font-bold text-white">
                Legal
              </h5>
              <ul className="list-none flex flex-col gap-4">
                <li className="text-base leading-6 font-normal text-[#FFFFFFE0]">
                  Terms of use
                </li>
                <li className="text-base leading-6 font-normal text-[#FFFFFFE0]">
                  Privacy Policy
                </li>
              </ul>
            </div> */}
            <div className="flex flex-col gap-5">
              <h5 className="m-0 text-lg leading-7 font-bold text-white">
                Support
              </h5>
              <div className="flex items-center gap-4">
                <img src={MailIcon} alt="emailIcon" />
                <span className="text-base leading-6 font-normal text-[#FFFFFFE0]">
                  contact@incognetolabs.com
                </span>
              </div>
            </div>
          </div>
          <div className="w-full pt-3">
            <span className="text-base leading-6 font-normal text-white">
              © 2024 incognetoLabs. All rights reserved.
            </span>
          </div>
        </div>
      </section>
      {/* Footer section end */}
    </div>
  );
};

export default Index;
